import { get, useFormContext } from "react-hook-form";

import { EMAIL_REGEX } from "@/utils";
import { InputField } from "@components/Field";
import { FieldProps } from "@components/Field/Field/InputField";

const Email = ({
  name = "email",
  required = false,
  ...props
}: Partial<FieldProps>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <InputField
      block
      label={L.USER_SETTINGS_GENERIC_EMAIL_LABEL}
      placeholder={L.USER_SETTINGS_FIELDS_EMAIL_PLACEHOLDER}
      type="email"
      errorMessage={get(errors, name)?.message}
      {...props}
      {...register(name, {
        required: { value: required, message: L.REQUIRED_FIELD_VALUE },
        pattern: { value: EMAIL_REGEX, message: L.INVALID_EMAIL },
      })}
    />
  );
};

export { Email };
